<template>
  <div class="content-games">
    <div v-if="game.name == 'coloration'">
      <ColorationGames />
    </div>
    <div v-else-if="game.name == 'tweet'">
      <TweetGames />
    </div>
    <div v-else-if="game.name == 'morse' || game.name == 'chappe' || game.name == 'baudot'">
      <CodeGames :gameName="game.name"/>
    </div>
  </div>
</template>

<script>
import ColorationGames from "../coloration/ColorationGames.vue";
import TweetGames from "../tweet/TweetGames.vue";
import CodeGames from "../morse-chappe-baudot/CodeGames.vue";

export default {
  name: "Base",
  components: {
    ColorationGames,
    TweetGames,
    CodeGames
  },
  props: {
    game: Object,
  },
  data: () => ({}),
};
</script>